import { lock, clearBodyLocks } from 'tua-body-scroll-lock';
import * as focusTrap from 'focus-trap';
class mPopin extends HTMLDivElement {
    constructor() {
        super();
        this.focusableElements = this.querySelectorAll('button, a, input, select, textarea');
        this.closePopinBtns = this.querySelectorAll('[data-close]');
        // bind this
        this.setPopinTrigger = this.setPopinTrigger.bind(this);
        this.togglePopin = this.togglePopin.bind(this);
        this.actionKeyboard = this.actionKeyboard.bind(this);
    }

    connectedCallback() {
        for (var closeBtn of this.closePopinBtns) {
            closeBtn.addEventListener('click', this.togglePopin);
        }
        document.addEventListener('click', this.setPopinTrigger);
        this.trap = focusTrap.createFocusTrap(this);
    }

    disconnectedCallback() {
        window.removeEventListener('keydown', this.actionKeyboard);
        var pagehasOpenedSidebar = document.querySelectorAll('[is="o-sidebar"][aria-expanded="true"], [is="o-sidebar-ajax"][aria-expanded="true"]').length !== 0;
        if (!pagehasOpenedSidebar) {
            // will work until a modal close goes to a non-sidebar scroll blocked state (not happening for now)
            clearBodyLocks();
        }
        this.trap.deactivate();
    }

    setPopinTrigger(e) {
        const btnTarget = e.target.closest('[data-target]');

        if (btnTarget && btnTarget.hasAttribute('data-target') && btnTarget.dataset.target === '#' + this.id) {
            this.togglePopin();
        }
    }

    togglePopin() {
        var toggleOpen = this.getAttribute('aria-hidden') === 'true';

        this.setAttribute('aria-hidden', !toggleOpen);
        this.setAttribute('tabindex', this.getAttribute('tabindex') === '-1' ? '0' : '-1');

        this.focusableElements.forEach((el) => {
            el.setAttribute('tabindex', el.getAttribute('tabindex') === '-1' ? '0' : '-1');
        });

        var pagehasOpenedSidebar = document.querySelectorAll('[is="o-sidebar"][aria-expanded="true"], [is="o-sidebar-ajax"][aria-expanded="true"]').length !== 0;

        if (toggleOpen) { // opening the modal
            setTimeout(() => { this.trap.activate(); }, 100); // Timeout to be sure the tabindex loop above has finished
            if (!pagehasOpenedSidebar) lock();
            window.addEventListener('keydown', this.actionKeyboard);
        } else { // closing the modal
            if (!pagehasOpenedSidebar) { clearBodyLocks(); } // will work until a modal close goes to a non-sidebar scroll blocked state (not happening for now)
            this.trap.deactivate();
            this.dispatchEvent(new Event('close'));
        }
    }

    actionKeyboard(event) {
        if (event.code === 'Escape') {
            if (this.getAttribute('aria-hidden') === 'false') {
                // To ensure that the sidepanel wont close before the popin, no value in timeout = wait one roud of event
                setTimeout(() => {
                    this.togglePopin();
                });
            }
        }
    }
}

customElements.define('m-popin', mPopin, {
    extends: 'div'
});
